interface SegmentedControlProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  size?: 'sm' | 'md';
}

export default function SegmentedControl({
  options,
  value,
  onChange,
  className = '',
  size = 'md',
}: SegmentedControlProps) {
  const sizeClasses = size === 'sm' ? 'px-3 py-1 text-xs' : 'px-3.5 py-1.5 text-xs sm:text-sm';

  return (
    <div
      className={`inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 ${className}`}
    >
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`${sizeClasses} rounded-full font-medium whitespace-nowrap transition-all duration-150 cursor-pointer ${
              active
                ? 'bg-primary-500 text-background-50 shadow-xs'
                : 'text-foreground-700 hover:bg-background-200/60 hover:text-foreground-950'
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
